import React from "react";
import AntdRadio, { RadioProps } from "antd/lib/radio";
import {withError} from '@fishx/tracker';

const Group = AntdRadio.Group;
const Button = AntdRadio.Button;

interface ForwardRadioProps extends RadioProps {
  forwardRef: any;
}

interface FCRadioProps extends React.FC<ForwardRadioProps>{
  Button: typeof Button;
  Group: typeof Group;
}

 export const Radio: FCRadioProps = (props) => {
  const { children, forwardRef, ...rest } = props;
  return (
    <AntdRadio {...rest} ref={forwardRef}>{children}</AntdRadio>
  );
}

Radio.Group = Group;
Radio.Button = Button;

export default withError(Radio, {forwardRef: true});


// WEBPACK FOOTER //
// ./src/components/radio/index.tsx